import axios from '../../../localAxios';
import { removeWorkspaceMemberURL } from '../../workspacesURLs';

interface RemoveMemberParams {
  workspaceId: string;
  userId: string;
}

export async function removeWorkspaceMember({
  workspaceId,
  userId,
}: RemoveMemberParams) {
  const result = await axios.delete(
    removeWorkspaceMemberURL(workspaceId, userId).href
  );
  return result.data;
}
